export const ENTITIES_RECEIVE = 'ENTITIES_RECEIVE';
export const ENTITIES_DELETE = 'ENTITIES_DELETE';

export const entitiesReceive = entities => ({
  type: ENTITIES_RECEIVE,
  payload: entities,
});
export const entitiesDelete = (schema, payload) => ({
  type: ENTITIES_DELETE,
  payload: { id: payload, schema },
});
